export const DEPT_REPORT_TABS = [
  {
    label: 'Vehicle Movement',
    id: 1,
    route: 'vehicle-movement',
  },
  {
    label: 'Generated Reports',
    id: 2,
    route: 'generated-reports',
  },
];

export const handleDeptReportTabClick = (id, onClick) => {
  const tab = DEPT_REPORT_TABS.find(item => item.id === id);
  if (!tab) {
    return;
  }
  onClick('statusRoute', {route: tab.route, id: tab.id});
};
